import React, { Component, ReactNode } from 'react'
import Card from './Card'
import Heading from './Heading'
import Logo from './Logo'

interface Props {
  heading: string
  description: string
  children: ReactNode
}

export default class AuthCard extends Component<Props> {
  render () {
    return (
      <Card>
        <div className="flex justify-between">
          <div className="block">
            <Heading text={this.props.heading} />
            <p className="text-secondary mb-5">
              {this.props.description}
            </p>
          </div>
          <Logo type="icon" />
        </div>
        {this.props.children}
      </Card>
    )
  }
}
